import { RichTextDisplay } from '@tempo-io/fim3-sui-shared';
import { Button } from '@tempo-io/sui-button';
import { Edit } from '@tempo-io/sui-icons';
import { useState } from 'react';
import { EmptyFieldValue } from '@/features/items/components/item-field-value/EmptyFieldValue';
import { FieldWithStatusIndicator } from '@/features/items/components/item-field-value/FieldWithStatusIndicator';
import { NoteEditDialog } from './NoteEditDialog';

export const NoteField = ({
  name,
  value,
  isEditable = false,
  onChange,
  isPending,
  isSuccess,
  isError,
  error,
}: {
  name: string;
  value?: string;
  isEditable?: boolean;
  onChange?: (value: string) => void;
  isPending?: boolean;
  isSuccess?: boolean;
  isError?: boolean;
  error?: Error | null;
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const openDialog = () => setDialogOpen(true);

  const handleSave = (newValue: string) => {
    onChange?.(newValue);
  };

  const action =
    isEditable && onChange ? (
      <Button
        variant="outline"
        size="icon-sm"
        onClick={openDialog}
        aria-label={name}
        disabled={isPending}
      >
        <Edit />
      </Button>
    ) : undefined;

  return (
    <>
      <FieldWithStatusIndicator
        name={name}
        isPending={isPending}
        isSuccess={isSuccess}
        action={action}
      >
        <div className="flex flex-col gap-1">
          {value ? <RichTextDisplay value={value} /> : <EmptyFieldValue />}
          {isError && error && <span className="text-xs text-text-error">{error.message}</span>}
        </div>
      </FieldWithStatusIndicator>
      {isEditable && (
        <NoteEditDialog
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          initialValue={value}
          onSave={handleSave}
        />
      )}
    </>
  );
};
